import './index.scss';
import Skeleton from '@mui/material/Skeleton';
import DashboardSkeleton from '../dashboard/skeleton';
import AddressListSkeleton from '../address-list/skeleton';

const LayoutSkeleton = ({myAccountSection}) => {
  return (

    <div className="container">
      <div className="my-account">
        <div className="row my-account__wrapper">
          <div className="col-sm-4 col-md-3">
            <div className="my-account__menu dashboard-skeleton">
              <h3 className="my-account__menu__heading">
                <Skeleton animation="wave" variant="rounded" className='myAccountMenuHeading' />
              </h3>
              <ul className="base links list--links my-account__menu__options">
                <li><a className='toggleContent bold my-account__menu__options--toggle' id="dashboard"><Skeleton animation="wave" variant="text" className="skeleton-menu-text" /></a></li>
                <li><a className='toggleContent bold my-account__menu__options--toggle' id="dashboard"><Skeleton animation="wave" variant="text" className="skeleton-menu-text" /></a></li>
                <li><a className='toggleContent bold my-account__menu__options--toggle' id="dashboard"><Skeleton animation="wave" variant="text" className="skeleton-menu-text" /></a></li>
                <li><a className='toggleContent bold my-account__menu__options--toggle' id="dashboard"><Skeleton animation="wave" variant="text" className="skeleton-menu-text" /></a></li>
                <li><a className='toggleContent bold my-account__menu__options--toggle' id="dashboard"><Skeleton animation="wave" variant="text" className="skeleton-menu-text" /></a></li>
                <li><a className='toggleContent bold my-account__menu__options--toggle' id="dashboard"><Skeleton animation="wave" variant="text" className="skeleton-menu-text" /></a></li>
              </ul>
            </div>
          </div>
          { myAccountSection === 'address' ? <div className="col-xs-12 col-sm-8 col-md-7">
              <AddressListSkeleton/> 
            </div> : <div className="col-xs-12 col-sm-8 col-md-8">
              <DashboardSkeleton /> 
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default LayoutSkeleton;
